//
import Card from './Card';
import Paper from './Paper';
import Input from './Input';
import Table from './Table';
import Button from './Button';
import Tooltip from './Tooltip';
import Backdrop from './Backdrop';
import Typography from './Typography';
import Popover from './Popover';
import Dialog from './Dialog';
import Focus from './Focus';
import Autocomplete from './Autocomplete';
import Switch from './Switch';
import Checkbox from './Checkbox';

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme) {
    return Object.assign(
        Card(theme),
        Table(theme),
        Input(theme),
        Paper(theme),
        Button(theme),
        Tooltip(theme),
        Backdrop(theme),
        Typography(theme),
        Autocomplete(theme),
        Popover(theme),
        Dialog(theme),
        Switch(theme),
        Checkbox(theme),
        Focus(theme)
    );
}
